"use client";

import { Smartphone } from "lucide-react";
import { useTranslations } from "next-intl";
import { useGetApp } from "./get-app-provider";

interface GetAppMenuItemProps {
  onNavigate?: () => void;
}

export function GetAppMenuItem({ onNavigate }: GetAppMenuItemProps) {
  const t = useTranslations("Sidebar");
  const { canGetApp, canInstallOnDesktop, openGetApp, openDesktopInstall } =
    useGetApp();
  const open = canInstallOnDesktop ? openDesktopInstall : openGetApp;

  if (!canInstallOnDesktop && !canGetApp) {
    return null;
  }

  const handleClick = () => {
    if (onNavigate) {
      onNavigate();
      window.setTimeout(open, 300);
      return;
    }

    open();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex cursor-pointer items-center gap-1 rounded-md px-1.5 py-1.5 text-xs font-medium text-(--mk-cream-60) transition-colors hover:bg-(--mk-cream-surface) hover:text-(--mk-cream)"
    >
      <Smartphone className="h-3.5 w-3.5 shrink-0" />
      {canInstallOnDesktop ? t("installAppShort") : t("getAppShort")}
    </button>
  );
}
